import axios from 'axios';

const api = axios.create({
  baseURL:"https://followize-api.agnus.app/"
})

export default api;
